import _taggedTemplateLiteral from "/builds/schumacherweb/devbridge/scp-web-client/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/taggedTemplateLiteral";

function _templateObject2() {
  var data = _taggedTemplateLiteral(["\n  align-items: center;\n  display: inline-flex;\n  position: relative;\n"]);

  _templateObject2 = function _templateObject2() {
    return data;
  };

  return data;
}

function _templateObject() {
  var data = _taggedTemplateLiteral(["\n  left: ", ";\n  position: absolute;\n  top: ", ";\n"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

import React from 'react';
import styled from 'styled-components';
import { baselineToRem } from '@scp/ui-shared/theme/utils';
import { Icon } from '@scp/ui-shared/theme/icons';
import { Badge } from './Badge';
var TEXT = {
  TITLE: function TITLE(count) {
    return "Badge count: ".concat(count);
  }
};
var BadgeWrapper = styled.span(_templateObject(), baselineToRem(3), baselineToRem(-2));
var IconWithBadgeWrapper = styled.span(_templateObject2());
export var IconWithBadge = function IconWithBadge(_ref) {
  var iconName = _ref.iconName,
      count = _ref.count,
      children = _ref.children,
      badgeTitle = _ref.badgeTitle;
  if (typeof count === 'undefined') return children;
  return React.createElement(IconWithBadgeWrapper, null, iconName && React.createElement(Icon, {
    name: iconName,
    size: baselineToRem(5)
  }), children, React.createElement(BadgeWrapper, null, React.createElement(Badge, {
    title: badgeTitle || TEXT.TITLE(count),
    count: count
  })));
};